import { useMemo } from 'react';
import { useGetAllCourierPartnersCachedQuery } from '../redux/commonRTK';

/**
 * Shared hook that fetches all courier partners (cached) and returns a
 * lookup function to resolve a courier's serviceTypePrimary by prozoId.
 *
 * RTK Query deduplicates identical requests, so multiple components
 * calling this hook share a single cached result.
 *
 * Usage:
 *   const { getServiceType } = useCourierServiceType();
 *   const serviceType = getServiceType(row.courierDetail?.prozoId);
 */
export default function useCourierServiceType() {
  const { data, isLoading } = useGetAllCourierPartnersCachedQuery({
    andfilter: [
      { field: "is_deleted", operator: "eq", value: '0' },
      { field: "isActive", operator: "eq", value: true },
      { field: "isExternal", operator: "eq", value: false },
    ],
    offset: 0,
    limit: 500,
    skipCount: true,
    includes: "id,name,parent,prozoId,supportedShipmentType,serviceTypePrimary",
  });

  const serviceTypeMap = useMemo(() => {
    const map = new Map();
    if (Array.isArray(data)) {
      data.forEach((c) => {
        if (c.prozoId && c.serviceTypePrimary) {
          map.set(c.prozoId, c.serviceTypePrimary);
        }
      });
    }
    return map;
  }, [data]);

  const getServiceType = (prozoId) => {
    if (!prozoId) return '';
    return serviceTypeMap.get(prozoId) || '';
  };

  return { getServiceType, data, isLoading };
}
